import "./garden-loading.css";

const moments = [
  [
    "Give your ideas somewhere to grow.",
    "Keep documents, decisions, and useful context together.",
  ],
  [
    "Good context grows together.",
    "Give your teammates and agents a shared place to build.",
  ],
  [
    "Grow something useful.",
    "Turn shared knowledge into apps and everyday workflows.",
  ],
];

/** A decorative loop only: request completion always controls when we leave. */
export function GardenLoading() {
  return (
    <main className="garden-opening">
      <div className="garden-opening-content">
        <p className="garden-opening-brand">Garden <span>by Sauna</span></p>
        <svg
          className="garden-opening-illustration"
          viewBox="0 0 320 280"
          aria-hidden="true"
          focusable="false"
        >
          <circle className="garden-opening-halo" cx="160" cy="131" r="105" />
          <circle className="garden-opening-orbit" cx="160" cy="131" r="121" />
          <path className="garden-opening-ground" d="M62 203 Q160 193 258 203 M94 215 Q160 210 226 215" />
          <g className="garden-opening-cycle">
            <g className="garden-opening-roots">
              <path pathLength="1" d="M160 199 C159 218 165 231 158 247" />
              <path pathLength="1" d="M161 213 C145 216 141 231 130 233 M162 223 C178 224 181 236 190 239 M148 222 L145 239" />
            </g>
            <ellipse className="garden-opening-seed" cx="160" cy="198" rx="6" ry="9" transform="rotate(24 160 198)" />
            <path className="garden-opening-stem" pathLength="1" d="M160 197 C151 173 171 145 160 116 C155 102 157 84 162 70" />
            <g className="garden-opening-leaves">
              <path d="M161 171 C134 171 120 155 119 136 C143 138 159 148 161 171Z" />
              <path d="M162 150 C164 126 183 117 201 118 C195 141 181 150 162 150Z" />
              <path d="M160 120 C141 119 132 106 133 93 C151 96 159 105 160 120Z" />
              <path className="garden-opening-vein" d="M160 170 L129 146 M163 149 L191 127 M159 118 L139 101" />
            </g>
            <g className="garden-opening-flower">
              <g transform="translate(162 68)">
                {[0, 60, 120, 180, 240, 300].map((angle) => (
                  <ellipse key={angle} cx="0" cy="-12" rx="7" ry="13" transform={`rotate(${angle})`} />
                ))}
                <circle className="garden-opening-flower-center" r="7" />
              </g>
            </g>
            <g className="garden-opening-pollen">
              <path d="M113 73 v8 M109 77 h8 M211 87 v6 M208 90 h6" />
              <circle cx="194" cy="45" r="2" />
              <circle cx="108" cy="113" r="2" />
            </g>
          </g>
        </svg>
        <h1 className="garden-opening-title" role="status">Opening your garden…</h1>
        <div className="garden-opening-moments" aria-hidden="true">
          {moments.map(([title, description], index) => (
            <div className="garden-opening-moment" key={title} style={{ animationDelay: `${index * 3}s` }}>
              <p className="garden-opening-tip">{title}</p>
              <p className="garden-opening-description">{description}</p>
            </div>
          ))}
        </div>
        <div className="garden-opening-dots" aria-hidden="true">
          {moments.map(([title], index) => (
            <span key={title} style={{ animationDelay: `${index * 3}s` }} />
          ))}
        </div>
      </div>
    </main>
  );
}
